
import { Component, Mixins } from 'vue-property-decorator';
import Chart from 'chart.js';
import { Doughnut, mixins } from 'vue-chartjs';

@Component({})
export default class Chart1 extends Mixins(Doughnut, mixins.reactiveProp) {
  private data: Chart.ChartData = {
    labels: ['', ''],
    datasets: [
      {
        label: 'Pattern2',
        type: 'doughnut',
        data: [55, 45],
        backgroundColor: ['#4384f3', '#edf4ff'],
        // ボーダー削除
        borderColor: 'transparent',
        // ドーナツ上のデータラベル削除
        datalabels: {
          display: false,
        },
      },
    ],
  };

  private options: Chart.ChartOptions = {
    tooltips: {
      enabled: false,
    },
    // ドーナツの細さ、円中心から何％カットするかを指定する
    cutoutPercentage: 88,
    // アニメーションの非活性
    // animation:false,
    // 凡例の削除
    legend: {
      display: false,
    },
  };
  private mounted() {
    // ドーナツの中心にテキストを表示
    this.addPlugin({
      afterDraw(chart: any, go: any) {
        const ctx = chart.ctx;

        chart.data.datasets.forEach((dataset: any, i: any) => {
          let dataSum = 0;
          dataset.data.forEach((element: any) => {
            dataSum += element;
          });
          const meta = chart.getDatasetMeta(i);
          if (!meta.hidden) {
            meta.data.forEach((element: any, index: any) => {
              // フォントの設定
              const fontSize = 28;
              const fontStyle = 'normal';
              const fontFamily = '游ゴシック';
              ctx.fillStyle = '#4384f3';
              ctx.font = Chart.helpers.fontString(
                fontSize,
                fontStyle,
                fontFamily
              );

              ctx.textAlign = 'left';
              ctx.textBaseline = 'middle';
              const padding = -2;
              const position = element.tooltipPosition();
              // ツールチップに変更内容を表示
              ctx.fillText('58', chart.width / 2 - 16, chart.height / 2);
            });
          }
        });
      },
    });
    // グラフを描画
    this.renderChart(this.data, this.options);
  }
}
